import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Por qué contrataría a alguien sin experiencia con clientes?',
  a: 'Porque experiencia con clientes no es lo mismo que conocimiento real. Tenemos formación en marketing, herramientas actualizadas y algo que ninguna agencia puede tener: conocemos la Quebrada desde adentro.'
}, {
  q: 'Ya lo intenté y no funcionó. ¿Por qué sería distinto?',
  a: 'Antes de proponer nada, entendemos tu negocio. No aplicamos fórmulas genéricas. Explicamos cada decisión. Si algo no funciona, lo ajustamos juntos.'
}, {
  q: '¿No puedo hacerlo yo solo con las IAs?',
  a: 'Podés. Pero las IAs no conocen la Quebrada. Producen volumen sin identidad. Y la identidad es lo que diferencia un negocio memorable de uno que se olvida.'
}, {
  q: '¿Vale la pena invertir con la economía así?',
  a: 'Los negocios que se ven, se eligen. Los que no se ven, cierran. La presencia digital es lo que te mantiene visible cuando el contexto aprieta.'
}, {
  q: '¿Cómo sé que van a estar cuando los necesite?',
  a: 'Porque somos del lugar. No nos vamos a ningún lado. Acceso directo por WhatsApp, respuesta en el día, sin intermediarios.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-32 bg-arena px-5 md:px-8" data-id="element-55">
      <div className="max-w-[800px] mx-auto" data-id="element-56">
        <div className="text-center mb-16" data-id="element-57">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-terracota font-nunito text-sm uppercase tracking-[0.1em] font-bold block mb-4" data-id="element-58">
            Preguntas frecuentes
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-negro" data-id="element-59">
            Todo lo que querés saber antes de empezar.
          </motion.h2>
        </div>

        <div className="space-y-2" data-id="element-60">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 * index
          }} className="border-b border-terracota/20" data-id="element-61">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-62">
                  <span className={`font-playfair text-xl md:text-2xl font-bold pr-8 transition-colors duration-250 ${isOpen ? 'text-terracota' : 'text-negro group-hover:text-terracota'}`} data-id="element-63">
                    {faq.q}
                  </span>
                  <div className="flex-shrink-0 text-terracota" data-id="element-64">
                    {isOpen ? <Minus size={24} data-id="element-65" /> : <Plus size={24} data-id="element-66" />}
                  </div>
                </button>
                <AnimatePresence data-id="element-67">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-68">
                      <p className="pb-6 font-nunito text-negro/70 text-lg leading-relaxed" data-id="element-69">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}